// Értesítés-típus → ikon. A repo IKON-STANDARDJA a Heroicons (`@heroicons/react`) — kézi SVG TILOS.
// Az ikonok a sidebar/nav (`nav-config.ts`) és a globális kereső (`search-targets.ts`) ikon-választását
// követik, hogy a harang-sor ránézésre ugyanahhoz a modulhoz kötődjön, mint a menüpont.
import {
  ArrowPathIcon,
  BellIcon,
  CalendarIcon,
  ChatBubbleLeftEllipsisIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClockIcon,
  CreditCardIcon,
  CubeIcon,
  ExclamationTriangleIcon,
  FaceSmileIcon,
  LinkIcon,
  NoSymbolIcon,
  PencilSquareIcon,
  ShoppingCartIcon,
  TicketIcon,
  UserMinusIcon,
  UsersIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { type ComponentType, type SVGProps } from 'react';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

/** Típus → ikon (a harang minden in-app típusa). Az ISMERETLEN típus a harang-ikont kapja (generikus). */
const TYPE_ICONS: Record<string, IconComponent> = {
  'ticket.opened': TicketIcon,
  'ticket.assigned': TicketIcon,
  'ticket.status_changed': ArrowPathIcon,
  'ticket.closed': CheckCircleIcon,
  'ticket.resolved': CheckCircleIcon,
  'ticket.comment.external': ChatBubbleLeftEllipsisIcon,
  // Megosztás → EMBEREK (nem chat): a jelentés az, hogy valaki mostantól láthatja a jegyet.
  'ticket.access_granted': UsersIcon,
  'ticket.comment.internal': ChatBubbleLeftEllipsisIcon,
  // A REAKCIÓ nem hozzászólás: nem chat-buborék, hanem mosolygó arc — a feedben egy pillantással
  // elkülönül a „valaki válaszolt" soroktól.
  'ticket.comment.reaction': FaceSmileIcon,
  'message.received': ChatBubbleLeftRightIcon,
  // Figyelmeztetés (nem üzenet-tartalom): a küldő címzett-listája csonkolt lett.
  'message.delivery_truncated': ExclamationTriangleIcon,
  'meeting.invited': CalendarIcon,
  'meeting.rescheduled': ArrowPathIcon,
  'meeting.cancelled': NoSymbolIcon,
  'meeting.removed': UserMinusIcon,
  'meeting.link_changed': LinkIcon,
  'meeting.reminder': ClockIcon,
  'asset.requested': CubeIcon,
  'asset.approved': CheckCircleIcon,
  'asset.rejected': XCircleIcon,
  'asset.purchased': ShoppingCartIcon,
  'asset.approved_info': CheckCircleIcon,
  'asset.request_updated': PencilSquareIcon,
  // Előfizetés-lejárat — IDŐ-alapú figyelmeztetés (mint a hamarosan induló hozzárendelésé).
  'asset.expiring': ClockIcon,
  'payment_card.expiring': CreditCardIcon,
  'payment_card.expired': CreditCardIcon,
  // Hamarosan induló, függő hozzárendelés — az óra jelzi, hogy IDŐ-alapú figyelmeztetésről van szó.
  'service_assignment.pending_start_soon': ClockIcon,
  // ── MIGRÁLT LEGACY TÍPUSOK ────────────────────────────────────────────────────────────────────────────
  // A migrált CRM-értesítések kulcsai mások (`open` ↔ `opened`, `comment` ↔ `comment.external`, …). Ikon
  // nélkül MINDEGYIK a generikus harangot kapta, tehát a panelben 15 azonos sor állt — a típus-ikon az
  // első, egy pillantással olvasható jel. Ugyanazt az ikont kapják, mint a mai párjuk.
  'ticket.open': TicketIcon,
  'ticket.close': CheckCircleIcon,
  'ticket.status_change': ArrowPathIcon,
  'ticket.assign': TicketIcon,
  'ticket.comment': ChatBubbleLeftEllipsisIcon,
  'message.new': ChatBubbleLeftRightIcon,
  'meeting.new': CalendarIcon,
  'meeting.reschedule': ArrowPathIcon,
  'meeting.delete': NoSymbolIcon,
  'asset.request': CubeIcon,
  'asset.approve': CheckCircleIcon,
  'asset.reject': XCircleIcon,
  'asset.purchase': ShoppingCartIcon,
  // A dokumentumtár-modul ⛔ elvetve; a migrált sor (1 db) így is beszédes ikont kap.
  'document.alert': ExclamationTriangleIcon,
};

/** Egy értesítés-típus ikonja; ismeretlen típus → harang (a lista nem törik meg). */
export function iconForNotificationType(type: string): IconComponent {
  return TYPE_ICONS[type] ?? BellIcon;
}
